import { render, staticRenderFns } from "./MyBots.vue?vue&type=template&id=b49f50aa&scoped=true&"
import script from "./MyBots.vue?vue&type=script&lang=js&"
export * from "./MyBots.vue?vue&type=script&lang=js&"
import style0 from "./MyBots.vue?vue&type=style&index=0&id=b49f50aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f50aa",
  null
  
)

export default component.exports